module.exports = __webpack_public_path__ + "img/culture.e107235b.png";